import { ContentCompact, HeaderFunnel } from '@ferreri/prever-component-lib';
import { PetAssistanceHasBenefit } from './PetAssistanceHasBenefit';
import { useRouter } from 'next/router';

export const PetAssistance = () => {
  const router = useRouter();

  return (
    <ContentCompact>
      <HeaderFunnel onClickArrow={router.back}>Assistência Pet</HeaderFunnel>
      <PetAssistanceHasBenefit />
    </ContentCompact>
  );
};
